import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('DriverFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getNewDriver: function () {
            return $http.get(settings.ApiURL + settings.DriverURL + "/newdriver");
        },
        getDriverDetails: function (id) {
            return $http.get(settings.ApiURL + settings.DriverURL + "/" + id);
        },
        saveDriver: function (Driver) {
            return $http.put(settings.ApiURL + settings.DriverURL, Driver);
        },
        deleteDriver: function (id) {
            return $http.delete(settings.ApiURL + settings.DriverURL + "/" + id);
        },
        getDriverList: function () {
            return $http.get(settings.ApiURL + settings.DriverURL);
        },
        getLanguages: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/languages/0")
        },
        getDriverRoles: function (id) {
            return $http.get(settings.ApiURL + settings.DriverURL + '/roles');
        }
    };
}]);

app.controller('DriverController', ['$q', '$scope', 'DriverFactory', '$rootScope', 'settings', 'masterFactory',
                function ($q, $scope, DriverFactory, $rootScope, settings, masterFactory) {
    $rootScope.pageTitle = "Driver";
    $scope.ActiveInactiveDriverLookup = [
        { Deleted: false, Text: 'Active' },
        { Deleted: true, Text: 'InActive' }
    ];    
    $scope.driver = {};
    $scope.driverList = [];        
    $scope.newDriver = {};
    $scope.languages = [];
    $scope.error = "";    
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;

    // Initialization - this runs on load
    var init = function () {
        masterFactory.verifyAuthentication();
        
        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            DriverFactory.getNewDriver().success(function (data) {
                $scope.newDriver = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            DriverFactory.getLanguages().success(function (data) {
                $scope.languages = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            DriverFactory.getDriverRoles().success(function (data: any[]) {
                $scope.driverRoles = data.filter(r=>r.id != 0);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
        ]).then(function () {
            DriverFactory.getDriverList().success(function (data) {
                $scope.driverList = data;
                $scope.refreshGrid(0);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        });

    };

    var getDriverDetails = function (id) {
        DriverFactory.getDriverDetails(id).success(function (data) {
            $scope.driver = data;
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    init();

    $scope.refreshGrid = function (PageIndex) {
        $('#gridDriver').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.driverList,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Drivers Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: PageIndex
            },
            scrolling: {
                mode: 'standard'
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
                {
                    caption: 'Icon', dataField: 'Deleted', dataType: 'boolean', alignment: 'center', width: '100px',
                    cellTemplate: function (cellElement, cellInfo) {
                        if (cellInfo.data.Deleted == true) {
                            $("<span />")
                            .attr("class", "status-icon-closed-by-driver InActive")
                            .appendTo(cellElement);
                        }
                        else {
                            $("<span />")
                            .attr("class", "status-icon-closed-by-driver Active")
                            .appendTo(cellElement);
                        }
                        //if (cellInfo.value == true)
                        //    cellElement.addClass("icon-closed-by-driver InActive");
                        //else cellElement.addClass("icon-closed-by-driver Active");
                    },
                    lookup: { dataSource: $scope.ActiveInactiveDriverLookup, valueExpr: 'Deleted', displayExpr: 'Text' }
                },                
                { caption: 'Driver ID', dataField: 'Id', cssClass: 'Id', dataType: 'number', alignment: 'center' },
                { caption: 'Driver No', dataField: 'Number', cssClass: 'Number', dataType: 'string' },
                { caption: 'Driver Name', dataField: 'Name', cssClass: 'Name', dataType: 'string' },
                { caption: 'Valid Until', dataField: 'ValidDate', cssClass: 'ValidDate', dataType: 'date', format: 'dd/MM/yyyy' }
            ],

            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    getDriverDetails(selectedRowsInfo.selectedRowsData[0].Id);
                }
                else {
                    $scope.driver = angular.copy($scope.newDriver);
                }

                $scope.isFormVisible = true;
                $scope.isDeleteVisible = true;
                ToggleYellowToGreen();
                $rootScope.pageTitle = "Driver";                
            }
        });
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Driver";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.Driver = angular.copy($scope.newDriver);
        ToggleGreenToYellow();
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridDriver').dxDataGrid('instance');
        dataGrid.clearSelection();        
        $scope.isFormVisible = false;
        $scope.DriverForm.$submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {
        if (type == 'update') { // get db driver and set to scope.Driver.
            getDriverDetails($scope.driver.Id);
        }
        else {
            angular.copy($scope.newDriver, $scope.driver);
        }        
        $scope.DriverForm.$setPristine();
        $scope.DriverForm.$submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Driver details were reset' });
    };

    $scope.submitForm = function () {
        if ($scope.DriverForm.$valid) {            
            $scope.saveDriver();
        }        
    };

    $scope.saveDriver = function () {
        $('#loadingModal').modal({ backdrop: 'static' });
        var pageindex, id;
        $scope.closeModelStateErrors();
        DriverFactory.saveDriver($scope.driver).success(function (data) {
            DriverFactory.getDriverList().success(function (data) {
                var dataGrid = $('#gridDriver').dxDataGrid('instance');
                $scope.pageSize = dataGrid.pageSize();
                pageindex = dataGrid.pageIndex();
                $scope.driverList = data;
                if ($scope.driver.Id <= 0) {
                    $scope.cancelForm();
                }
                $scope.refreshGrid(pageindex);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                if ($scope.driver.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Driver successfully' });
                }
                else {                    
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Driver successfully' });
                }
            });
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {
            $('#loadingModal').modal('hide');
        });
    }

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridDriver', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridDriver', settings.GridMarginHeight);
    }

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };
}]);